<div *ngIf="canRate" (click)="openRateModal()" class="blueColorHover">{{ 'rate_rate_note' | translate }}</div>

<div *ngIf="showRatingModal" class="rateModal">
  <div class="header">
    <div></div>
    <h3>{{ 'rate_rate_note' | translate }}</h3>
    <div class="close blueColorHover" (click)="closeRateModal()">
      <i class="pi pi-times"></i>
    </div>
  </div>
  <div class="sliderContainer">
    <div [ngClass]="{'myrate': myRating && myRating === 1}" class="rateCircle" (click)="handleRate(1)">1</div>
    <div [ngClass]="{'myrate': myRating && myRating === 2}" class="rateCircle" (click)="handleRate(2)">2</div>
    <div [ngClass]="{'myrate': myRating && myRating === 3}" class="rateCircle" (click)="handleRate(3)">3</div>
    <div [ngClass]="{'myrate': myRating && myRating === 4}" class="rateCircle" (click)="handleRate(4)">4</div>
    <div [ngClass]="{'myrate': myRating && myRating === 5}" class="rateCircle" (click)="handleRate(5)">5</div>
  </div>
  <app-primary-button label="{{ 'rate_save_rate' | translate }}" (action)="submitRate()" ></app-primary-button>
</div>
